import useUpdateParams from "hooks/useUpdateParams";
import { queryClient } from "lib/react-query";
import { useEffect, useState } from "react";
import {
  ArrowLeftCircleFill,
  ArrowRightCircleFill
} from "react-bootstrap-icons";
import { useSearchParams } from "react-router-dom";
import { invoiceDetailStore } from "store/invoiceDetailsStore";
export const InvoicePagination = ({ totalPages, tab }) => {
  const [searchParams] = useSearchParams();
  let page = searchParams.get("page_number") || 1;
  const [pageIndex, setPageIndex] = useState(page);
  const { isModalOpen } = invoiceDetailStore();
  const updateParams = useUpdateParams();
  useEffect(() => {
    if (!isModalOpen) {
      const handleKeyDown = (e) => {
        // Ignore key events if the target is an input, textarea, or content-editable element
        const tagName = document.activeElement.tagName.toLowerCase();
        const isEditable =
          document.activeElement.isContentEditable ||
          tagName === "input" ||
          tagName === "textarea" ||
          tagName === "select";
  
        if (!isEditable) {
          if (e.key === "ArrowLeft" && pageIndex > 1) {
            // Go to the previous page
            updateParams({ page_number: Number(pageIndex) - 1 });
            setPageIndex(pageIndex - 1);
            queryClient.invalidateQueries({ queryKey: ["combined-table"] });
          } else if (e.key === "ArrowRight" && pageIndex < totalPages) {
            // Go to the next page
            updateParams({ page_number: Number(pageIndex) + 1 });
            setPageIndex(pageIndex + 1);
            queryClient.invalidateQueries({ queryKey: ["combined-table"] });
          }
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [pageIndex, totalPages, updateParams, isModalOpen, tab]);
  
  useEffect(() => {
    setPageIndex(page);
  }, [page]);
  return (
    <div className="my-4">
      <button
        className="my-4 mx-2 btn bg-transparent p-0 btn-outline border-0"
        disabled={page == 1}
        onClick={() => {
          updateParams({ page_number: Number(page) - 1 });
          setPageIndex(page - 1);
          queryClient.invalidateQueries({ queryKey: ["combined-table"] });
        }}
      >
        <ArrowLeftCircleFill size={40} />
      </button>
      <span className="my-4 mx-2">
        <input
          value={pageIndex}
          onChange={(e) => setPageIndex(e.target.value)}
          onBlur={() => {
            if (pageIndex >= totalPages) {
              setPageIndex(totalPages);
              updateParams({ page_number: totalPages });
              queryClient.invalidateQueries({ queryKey: ["combined-table"] });
            } else if (pageIndex <= 1) {
              setPageIndex(1);
              updateParams({ page_number: 1 });
              queryClient.invalidateQueries({ queryKey: ["combined-table"] });
            } else {
              updateParams({ page_number: pageIndex });
              queryClient.invalidateQueries({ queryKey: ["combined-table"] });
            }
          }}
          className="btn btn-secondary"
          style={{ width: "9ch" }}
        />
        <span className="my-4">
          {" "}
          <strong>/</strong>{" "}
          {totalPages ? (
            <input
              disabled
              value={`${totalPages}`}
              className="btn btn-secondary"
              style={{ width: "9ch", cursor: "default" }}
            />
          ) : (
            <input
              disabled
              value={`${pageIndex}`}
              className="btn btn-secondary"
              style={{ width: "9ch", cursor: "default" }}
            />
          )}
        </span>
      </span>
      <button
        className="my-4 mx-2 btn bg-transparent p-0 btn-outline border-0"
        disabled={totalPages == 1 || totalPages == page}
        onClick={() => {
          if (page <= totalPages) {
            setPageIndex(Number(page) + 1);
            updateParams({ page_number: Number(page) + 1 });
            queryClient.invalidateQueries({ queryKey: ["combined-table"] });
          }
        }}
      >
        <ArrowRightCircleFill size={40} />
      </button>
    </div>
  );
};
